"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBar = void 0;
var react_1 = __importDefault(require("react"));
var css_1 = require("@emotion/css");
exports.TextBar = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className;
    var textBarCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0;\n    display: flex;\n    flex-flow: column wrap;\n\n    @media (width >= 768px) {\n      flex-direction: row;\n    }\n\n    list-style: none;\n    line-height: normal;\n    margin-bottom: 0px;\n  "], ["\n    padding: 0;\n    display: flex;\n    flex-flow: column wrap;\n\n    @media (width >= 768px) {\n      flex-direction: row;\n    }\n\n    list-style: none;\n    line-height: normal;\n    margin-bottom: 0px;\n  "])));
    return (react_1.default.createElement("ul", { className: (0, css_1.cx)(textBarCss, className), ref: ref }, children));
});
exports.TextBar.displayName = 'TextBar';
var templateObject_1;
